import { Controller } from "@hotwired/stimulus"

// Browsers DON'T enforce <input accept="..."> when files are assigned
// programmatically, so we mimic the native filtering ourselves before
// handing the files off to the form's autosubmit handler.
export default class extends Controller {
  static targets = ["dropArea", "input"]

  dragover(event) {
    event.preventDefault()
    this.dropAreaTarget.classList.add("border-indigo-500", "bg-indigo-50")
  }

  dragleave(event) {
    event.preventDefault()
    this.dropAreaTarget.classList.remove("border-indigo-500", "bg-indigo-50")
  }

  drop(event) {
    event.preventDefault()
    this.dropAreaTarget.classList.remove("border-indigo-500", "bg-indigo-50")

    const dropped = Array.from(event.dataTransfer.files)
    if (dropped.length === 0) return

    const accepted = this.filterByAccept(dropped)
    if (accepted.length === 0) {
      this.flashRejection()
      return
    }

    const transfer = new DataTransfer()
    accepted.forEach(file => transfer.items.add(file))
    this.inputTarget.files = transfer.files
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  filterByAccept(files) {
    const accept = (this.inputTarget.accept || "").trim()
    if (accept === "") return files

    const patterns = accept.split(",").map(p => p.trim().toLowerCase()).filter(Boolean)
    return files.filter(file => patterns.some(pattern => this.matches(file, pattern)))
  }

  matches(file, pattern) {
    const type = (file.type || "").toLowerCase()
    const name = (file.name || "").toLowerCase()

    if (pattern.startsWith(".")) return name.endsWith(pattern)
    if (pattern.endsWith("/*")) return type.startsWith(pattern.slice(0, -1))
    return type === pattern
  }

  flashRejection() {
    this.dropAreaTarget.classList.add("border-red-500", "bg-red-50")
    setTimeout(() => {
      this.dropAreaTarget.classList.remove("border-red-500", "bg-red-50")
    }, 1500)
  }
}
